import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import AIChat from './AIChat';

export default function AIChatIcon() {
  const { user, config } = useAuth();
  const [open, setOpen] = useState(false);

  if (!user || !user.permissions?.use_ai_chat) return null;
  if (!config?.aiAvailable) return null;

  return (
    <>
      {open && <AIChat onClose={() => setOpen(false)} />}
      <button className="ai-chat-icon" onClick={() => setOpen(!open)} title={open ? 'Close AI Chat' : 'Ask Nucleus AI'}>
        {open ? (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        ) : (
          <img src="/nucleusai.png" alt="Nucleus AI" style={{ width: '36px', height: '36px', objectFit: 'contain' }} />
        )}
      </button>
    </>
  );
}
